import styled, { css } from 'styled-components';
import { COLOR_INDICATOR_WIDTH } from '../consts';

const ColorIndicatorElement = styled.div<{
  $isGroup?: boolean;
}>`
  min-width: ${COLOR_INDICATOR_WIDTH}px;
  height: 20px;

  ${({ $isGroup }) =>
    $isGroup &&
    css`
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
    `}
`;

type ColorIndicatorProps = {
  isGroup?: boolean;
  color?: string;
};

const ColorIndicator = ({ isGroup, color }: ColorIndicatorProps) => (
  <ColorIndicatorElement
    $isGroup={isGroup}
    style={color ? { backgroundColor: color } : undefined}
    aria-label={`Component color indicator: ${color}`}
  />
);

export { ColorIndicator };
